<wbo-edit-page #editPage [title]="model.data.name" [formGroup]="editPage.formGroup" (saving)="handleSave()"
               (addingAnother)="addingAnother($event)">
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.custom-group.edit.formation.details', formControlNames: ''}">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-append-field>
                            <wbo-text-edit-control formControlName="name"
                                                   [(ngModel)]="model.data.name"></wbo-text-edit-control>
                            <wbo-entity-discontinued-edit-control formControlName="discontinued"
                                                                  [(ngModel)]="model.data.discontinued"></wbo-entity-discontinued-edit-control>
                        </fui-append-field>
                        <ng-container formGroupName="customObjectType">
                            <wbo-custom-object-type-single-select-edit-control formControlName="customObjectTypeId"
                                                                               [(ngModel)]="model.data.customObjectType.customObjectTypeId"
                                                                               [objectValue]="model.data.customObjectType"
                                                                               [productLineContext]="productLineContext"
                                                                               [inventoryContext]="inventoryContext"
                                                                               [outletContext]="outletContext"
                                                                               [membershipTypeContext]="membershipTypeContext"
                                                                               [readonly]="editPage.editMode !== EditMode.ADD || groupTypeLocked"
                                                                               (onSelect)="customObjectTypeSelected()"
                                                                               (onClear)="customObjectTypeCleared()">
                            </wbo-custom-object-type-single-select-edit-control>
                        </ng-container>
                    </fui-column>
                    <fui-column>
                        <wbo-textarea-edit-control formControlName="description"
                                                   [(ngModel)]="model.data.description"></wbo-textarea-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.custom-group.edit.formation.custom-fields', formControlNames: 'customObjectFieldValues'}">
        <fui-rows *ngIf="model.data.customObjectType.customObjectTypeId">
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-edit-grid [data]="model.data.customObjectFieldValues"
                                       [editable]="true"
                                       [removable]="false"
                                       [emptyTitle]="'wbo.custom-group.edit.message.customObjectFieldValues.empty.title'"
                                       [emptyDescription]="'wbo.custom-group.edit.message.customObjectFieldValues.empty.description'"
                                       [entityPath]="'customObjectFieldValues'">
                            <wbo-text-column field="fieldName"></wbo-text-column>
                            <wbo-text-column field="fieldValue" [editable]="true"></wbo-text-column>
                        </wbo-edit-grid>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
</wbo-edit-page>
